import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../containers';
import { RiCloseLine } from 'react-icons/ri';
import HexagonBackground from '../components/products/HexagonBackground';
import './pages.css';

// Import all images from assets/service
import s1 from '../assets/service/service (1).jpg';
import s2 from '../assets/service/service (2).jpg';
import s3 from '../assets/service/service (3).jpg';
import s4 from '../assets/service/service (4).jpg';
import s5 from '../assets/service/service (5).jpg';
import s6 from '../assets/service/service (6).jpg';
import s7 from '../assets/service/service (7).jpg';
import s8 from '../assets/service/service (8).jpg';
import s9 from '../assets/service/service (9).jpg';
import s10 from '../assets/service/service (10).jpg';
import s11 from '../assets/service/service (11).jpg';
import s12 from '../assets/service/service (12).jpg';
import s13 from '../assets/service/service (13).jpg';
import s14 from '../assets/service/service (14).jpg';
import s15 from '../assets/service/service (15).jpg';

const serviceImages = [
    { id: 1, img: s1, title: 'CHINA M7.9.7 / M7.8 / M7 IMMO OFF FILE REQUEST', subtitle: 'Professional IMMO OFF file request for China ECU models including Geely vehicles.' },
    { id: 2, img: s2, title: 'IMMO OFF ONLINE SERVICE KIA & HYUNDAI DELPHI MT38 / MT86', subtitle: 'IMMO OFF online service for Kia & Hyundai Delphi MT38 and MT86 ECUs.' },
    { id: 3, img: s3, title: 'IMMO OFF ONLINE SERVICE ISUZU (4JJ1-7 / 4JJ1-8 / 4HK1 / 4JK1)', subtitle: 'IMMO OFF online service for Isuzu DMAX, Lory, ETC — 2.5L & 3.0L. DPF and EGR solutions included.' },
    { id: 4, img: s4, title: 'IMMO OFF ONLINE SERVICE VAG', subtitle: 'Online IMMO OFF for VAG group (VW, Audi, Skoda) — IAW4LV, IAW4ML, IAW4HV, IAW4TV, IAW4AV, IAW4CV, IAW4MV, IAW7GV.' },
    { id: 5, img: s5, title: 'IMMO OFF ONLINE SERVICE KIA & HYUNDAI CPEGD2.X.X & CPGDSH2.X.X', subtitle: 'Supports CPEGD2.20.1, CPEGD2.20.2, CPEGD2.20.3, CPEGD2.20.4, CPGDSH2.26.1, CPGDSH2.26.3.' },
    { id: 6, img: s6, title: 'IMMO OFF ONLINE SERVICE KIA & HYUNDAI SIM2K', subtitle: 'Online IMMO OFF for SIM2K-14X, SIM2K-24X, SIM2K-34X, SIM2K-25X, SIM2K-26X, SIM2K-47.' },
    { id: 7, img: s7, title: 'IMMO OFF ONLINE SERVICE MITSUBISHI MELCO MHXXX', subtitle: 'Professional IMMO OFF online service for Mitsubishi Melco MHXXX series ECUs.' },
    { id: 8, img: s8, title: 'IMMO OFF ONLINE SERVICE TOYOTA GEN 1 / GEN 2 / GEN 3 DTC OFF', subtitle: 'DTC OFF online service for Toyota Gen 1, Gen 2, Gen 3. DPF and EGR solutions included.' },
    { id: 9, img: s9, title: 'IMMO OFF DENSO — MITSUBISHI L200 2.5L 4D56', subtitle: 'IMMO OFF for Mitsubishi L200 2.5L 4D56 Denso ECU. DPF and EGR solutions included.' },
    { id: 10, img: s10, title: 'IMMO OFF BOSCH EDC7C4 — MITSUBISHI CANTER 3.0L', subtitle: 'Professional IMMO OFF for Mitsubishi Canter 3.0L Bosch EDC7C4. DPF and EGR solutions included.' },
    { id: 11, img: s11, title: 'IMMO OFF EDC17 STAGE 1 — TUCSON 2.0L CRDI', subtitle: 'IMMO OFF EDC17 Stage 1 for Hyundai Tucson 2.0L CRDi. DPF and EGR solutions included.' },
    { id: 12, img: s12, title: 'IMMO OFF ONLINE SERVICE VAG GROUP BOSCH EDC17 / ME17 / MED17', subtitle: 'Fast and best online IMMO OFF service for VAG Group (VW, Skoda) Bosch EDC17, ME17, and MED17.' },
    { id: 13, img: s13, title: 'IMMO OFF TEMIC — MERCEDES TRUCK ACTROS MP1', subtitle: 'Fast and best IMMO OFF for Mercedes Truck Actros MP1. ECU: TEMIC, EEPROM: 93C86.' },
    { id: 14, img: s14, title: 'IMMO OFF CONTINENTAL SIMOS 18.1 — 06K 907 425 B', subtitle: 'Fast and best IMMO OFF service for Continental Simos 18.1 (Part No. 06K 907 425 B).' },
    { id: 15, img: s15, title: 'IMMO OFF ONLINE SERVICE ISUZU (4JJ1-7 / 4JJ1-8 / 4HK1 / 4JK1)', subtitle: 'Online IMMO OFF for Isuzu DMAX, Lory — 2.5L & 3.0L (4JJ1-7, 4JJ1-8, 4JJ3, 4HK1, 4JK1). DPF and EGR included.' },
];

const FileService = () => {
    const [selectedImg, setSelectedImg] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleServiceClick = (id) => {
        navigate(`/file-service/${id}`);
    };

    // Prevent scrolling when modal is open
    useEffect(() => {
        if (selectedImg) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [selectedImg]);

    return (
        <div className="gpt3__file-service">
            <HexagonBackground />

            <div className="gpt3__file-service_container section__padding">
                <motion.div
                    className="gpt3__file-service_heading"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <h1 className="gradient__text">Professional ECU File Services</h1>
                    <p>High-performance, dyno-tested ECU file modifications for professional tuners. Our solutions are engineered for maximum reliability and power.</p>
                </motion.div>

                <motion.div
                    className="gpt3__file-service_list"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <div className="gpt3__file-service_list-content">
                        {serviceImages.map((service, index) => (
                            <div key={index} className="gpt3__file-service_list-item" onClick={() => handleServiceClick(service.id)}>
                                <span className="list-number">{index + 1}.</span>
                                <span className="list-text">{service.title}</span>
                            </div>
                        ))}
                    </div>
                </motion.div>

                <motion.div
                    className="gpt3__file-service_gallery"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.1
                            }
                        }
                    }}
                >
                    {serviceImages.map((service, index) => (
                        <motion.div
                            className="gpt3__file-service_card"
                            key={index}
                            variants={{
                                hidden: { opacity: 0, scale: 0.8 },
                                visible: { opacity: 1, scale: 1 }
                            }}
                            whileHover={{ scale: 1.05 }}
                            onClick={() => handleServiceClick(service.id)}
                        >
                            <div className="gpt3__file-service_card-image">
                                <img src={service.img} alt={service.title} />
                            </div>
                            <h3 className="gradient__text">{service.title}</h3>
                            <p>{service.subtitle}</p>
                        </motion.div>
                    ))}
                </motion.div>
            </div>

            <AnimatePresence>
                {selectedImg && (
                    <motion.div
                        className="gpt3__file-service_modal"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setSelectedImg(null)}
                    >
                        <motion.div
                            className="gpt3__file-service_modal-content"
                            initial={{ scale: 0.8 }}
                            animate={{ scale: 1 }}
                            exit={{ scale: 0.8 }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <img src={selectedImg} alt="Full screen service" />
                            <RiCloseLine className="modal-close" onClick={() => setSelectedImg(null)} />
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            <Footer />
        </div>
    );
};

export default FileService;
